import { render, staticRenderFns } from "./Shortcuts.vue?vue&type=template&id=468c7a70&scoped=true"
import script from "./Shortcuts.vue?vue&type=script&lang=js"
export * from "./Shortcuts.vue?vue&type=script&lang=js"
import style0 from "./Shortcuts.vue?vue&type=style&index=0&id=468c7a70&prod&scoped=true&lang=css"
import style1 from "./Shortcuts.vue?vue&type=style&index=1&id=468c7a70&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "468c7a70",
  null
  
)

export default component.exports